module.exports = "<div class=mui-group-item :class=\"{'no-access': !access}\"> <div class=mui-group-item-hd> <slot name=hd> <p>{{title}}</p> <inline-desc v-if=inlineDesc>{{inlineDesc}}</inline-desc> </slot> </div> <div class=\"mui-group-item-bd mui-group-item-primary\"> <slot></slot> </div> <div class=mui-group-item-ft :class=\"{'with-arrow': withArrow}\"> <slot name=ft> {{rightDesc}} </slot> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/group-item/index.vue
 ** module id = 160
 ** module chunks = 0
 **/